import { nullToEmpty } from "@impero-com/common/utils/string";

import * as theme from "./theme.css";

function ToggleButton(props: ToggleButtonProps) {
    const { isCollapsed, className, onToggle } = props;
    const antClassName = "ant-table-row-expand-icon";
    return (
        <div
            className={`${antClassName} ${antClassName}${
                isCollapsed ? "-collapsed" : "-expanded"
            } ${nullToEmpty(className)}`}
            onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                onToggle();
            }}
        />
    );
}

interface ToggleButtonProps {
    isCollapsed: boolean;
    className?: string;
    onToggle: () => void;
}

function EmptyToggleButton(props: { className?: string }) {
    const { className } = props;
    return (
        <span className={`${theme.emptyToggle} ${nullToEmpty(className)}`} />
    );
}

export { ToggleButton, type ToggleButtonProps, EmptyToggleButton };
